import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "nefa_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && getToken()) {
      setToken(null);
      window.dispatchEvent(new Event("nefa-auth-expired"));
    }
    return Promise.reject(err);
  }
);

export const login = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  api.put("/auth/password", { current_password, new_password }).then((r) => r.data);
export const forgotPassword = (email) =>
  api.post("/auth/forgot-password", { email, base_url: window.location.origin }).then((r) => r.data);
export const resetPassword = (token, new_password) =>
  api.post("/auth/reset-password", { token, new_password }).then((r) => r.data);

export const getViewers = () => api.get("/viewers").then((r) => r.data);
export const addViewer = (email) => api.post("/viewers", { email }).then((r) => r.data);
export const deleteViewer = (id) => api.delete(`/viewers/${id}`).then((r) => r.data);
export const setViewerPassword = (new_password) =>
  api.put("/viewers/password", { new_password }).then((r) => r.data);
export const getSyncStatus = () => api.get("/sync/status").then((r) => r.data);

export const getStaff = (params) => api.get("/staff", { params }).then((r) => r.data);
export const getStaffById = (id) => api.get(`/staff/${id}`).then((r) => r.data);
export const getDepartments = () => api.get("/departments").then((r) => r.data);
export const getBirthdays = (year) => api.get("/birthdays", { params: { year } }).then((r) => r.data);
export const createStaff = (data, year) => api.post("/staff", data, { params: { year } }).then((r) => r.data);
export const updateStaff = (id, data) => api.put(`/staff/${id}`, data).then((r) => r.data);
export const deleteStaff = (id) => api.delete(`/staff/${id}`).then((r) => r.data);

export const getYears = () => api.get("/years").then((r) => r.data);
export const createYear = (label) => api.post("/years", { label }).then((r) => r.data);
export const activateYear = (label) => api.put("/years/activate", { label }).then((r) => r.data);
export const updateYear = (old_label, label, sheet_url) =>
  api.put("/years/update", { old_label, label, sheet_url }).then((r) => r.data);
export const deleteYear = (label) =>
  api.delete(`/years/${encodeURIComponent(label)}`).then((r) => r.data);

export const fullName = (s) => `${s.first_name} ${s.last_name}`;
export const initials = (s) =>
  `${(s.first_name || "?")[0]}${(s.last_name || "?")[0]}`.toUpperCase();
